import React from 'react';
import { IngestFile } from '@/redux/slices/slice_types';
import { useHistory } from 'react-router-dom';
import ReadyToRegisterButton from '@/components/_common/ReadyToRegisterButton';

interface FileIngestProps {
  ingestFile: IngestFile;
}

const FileIngest = ({ ingestFile }: FileIngestProps) => {
  const history = useHistory();
  const canIngest = ingestFile?.stage == 'ready_for_ingest';

  if (!canIngest) {
    return null;
  }

  const handleClick = () => {
    history.push(`/ingest-management/${ingestFile.id}`);
  };

  return <ReadyToRegisterButton color="warning" fileType={ingestFile.file_type} onClick={handleClick} />;
};

export default FileIngest;
